import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { AdminService } from './admin.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private router: Router, private adminService: AdminService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap(
        (event) => {
          this.adminService.updateLastActive();
        },
        (err) => {
          if (err.error.message === 'Invalid access token.') {
            this.adminService.logout(true);

            this.router.navigateByUrl('/login');
          }
        }
      )
    );
  }
}
